import { render } from "./DrawdownGuardBadge.vue?vue&type=template&id=2691e0ad&scoped=true"
import script from "./DrawdownGuardBadge.vue?vue&type=script&lang=js"
export * from "./DrawdownGuardBadge.vue?vue&type=script&lang=js"

import "./DrawdownGuardBadge.vue?vue&type=style&index=0&id=2691e0ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2691e0ad"]])

export default __exports__